import { SearchableCombobox, TSearchable } from '../../base/combobox'
import { useCombobox } from '@/helpers/useCombobox'
import { DocumentTypeOrientation } from '@/types'

interface Props {
  value: string
  onChange: (value: TSearchable | null) => void
  invalid: boolean
}
interface DocumentTypeOrientationItem {
  id: DocumentTypeOrientation
  name: string
}

const values: DocumentTypeOrientationItem[] = [
  { id: DocumentTypeOrientation.Portrait, name: 'Portrait' },
  { id: DocumentTypeOrientation.Landscape, name: 'Landscape' },
]

export const Selector = ({ value, onChange, invalid }: Props) => {
  const { items } = useCombobox<DocumentTypeOrientationItem>({
    pageInfo: undefined,
    querySelected: undefined,
    queryCollection: values,
    buildSearchable: item => item
  })

  return (
    <SearchableCombobox
      data={items}
      fetchMore={() => {}}
      includeBlank={false}
      invalid={invalid}
      loading={false}
      moreToFetch={false}
      refetch={() => {}}
      searchField=""
      value={items.find(d => d.id == value) || { id: value, name: value }}
      onChange={onChange}
    />
  )
}
